import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import { loginUser } from "../APIServices/Login/loginThunk";
import { resetAlert } from '../APIServices/alertSlice';
import './LoginPage.css';
import "bootstrap/dist/css/bootstrap.min.css";
import "../../index";
import Bowser from "bowser";
import { decryptUserInfo } from "../SharedFiles/decryption/Decryption";
import { FaEye, FaEyeSlash } from "react-icons/fa";

function LoginPage() {
  // State to handle form input values and errors
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [usernameError, setUsernameError] = useState("");
  const [passwordError, setPasswordError] = useState("");
  const [sessionExpired, setSessionExpired] = useState(false);
  const [Login, setLogin] = useState(false);
  const [isTabActive, setIsTabActive] = useState(true);
  const [showPassword, setShowPassword] = useState(false);
  const [showLoginForm, setShowLoginForm] = useState(false);
  const userAgent = window.navigator.userAgent;
  const userData = sessionStorage.getItem('user');
  // const decryptData = decryptUserInfo(userData);

  // Redux state
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { user, loading, isAuthenticated, error } = useSelector((state) => state.login);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowLoginForm(true);
    }, 1500); 

    return () => clearTimeout(timer);
  }, []);

  // Effect for session expiration check
  useEffect(() => {
    const expired = sessionStorage.getItem("sessionExpired") === "true";
    setSessionExpired(expired);
    if (expired) {
      sessionStorage.removeItem("sessionExpired");
    }
  }, []);

  // Handle tab visibility change
  useEffect(() => {
    const handleVisibilityChange = () => {
      if (document.visibilityState === "visible") {
        setIsTabActive(true);
        if (sessionExpired && error) {
          Swal.fire({
            position: "center",
            icon: "error",
            title: "Your session has expired. Please log in again.",
            showConfirmButton: false,
            timer: 5000,
          }).then(() => {
            sessionStorage.removeItem("sessionExpired");
          });
          dispatch(resetAlert());
        }
      } else {
        setIsTabActive(false);
      }
    };

    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [error, dispatch, sessionExpired]);

  // Handle input changes and validate for character limit
  const handleInputChange = (e, setValue, setError, characterLimit) => {
    const inputValue = e.target.value;
    if (inputValue.length <= characterLimit) {
      setValue(inputValue);
      setError(""); // Clear any previous error
    } else {
      setError(`Character limit exceeded. Maximum allowed: ${characterLimit}`);
    }
  };

  // Handle form submission and dispatch the login action
  const handleSubmit = (e) => {
    e.preventDefault();
    let hasError = false;

    if (!username.trim()) {
      setUsernameError("User Name is required.");
      hasError = true;
    } else {
      setUsernameError("");
    }

    if (!password.trim()) {
      setPasswordError("Password is required.");
      hasError = true;
    } else {
      setPasswordError("");
    }

    if (hasError) return;

    const browser = Bowser.getParser(userAgent);

    const body = {
      username: username,
      password: password,
      DeviceInfo: JSON.stringify(browser.parsedResult)
    }
    setLogin(true);
    // Dispatch loginUser thunk with user credentials
    dispatch(loginUser(body));

  };


  // Effect to navigate when the user is authenticated
  useEffect(() => {
    if (user) {

      // const parsedUser = JSON.parse(user); // Assuming the user is stored as a stringified object
      const decryptedUser = decryptUserInfo(user);

      if (isAuthenticated && (decryptedUser[0]?.CATEGORY === 'S1' || decryptedUser[0]?.CATEGORY === 'C1')) {
        // Once authenticated and userData is available, navigate
        navigate("/sales/");
      } else if (isAuthenticated && decryptedUser[0]?.CATEGORY === 'P1') {
        // Once authenticated and userData is available, navigate
        navigate("/production");
      }
    }
    setLogin(false);
  }, [isAuthenticated, navigate, user, Login]);


  // Effect to show error alert when authentication fails
  useEffect(() => {
    if (error) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: error,
        showConfirmButton: false,
        timer: 5000,
      });
    }
  }, [error]);
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword); // Toggle the visibility of the password
  };
  return (
    <>
     {!showLoginForm && (
        <div className="splash-screen d-flex justify-content-center align-items-center vh-100">
          <img
            src="melwa-logo.png"
            alt="Melwa Logo"
            className="splash-logo"
            width="120"
            height="33"
          />
        </div>
      )}
         {showLoginForm && (
      <div className="d-flex justify-content-center align-items-center vh-100" style={{ backgroundColor: "#f8f9fa" }}>
        <div className="form-container p-4 bg-white rounded shadow-sm" style={{ maxWidth: "400px", width: "100%" }}>

          <form onSubmit={handleSubmit}>

            <img className="mb-4 mx-auto d-block" src="melwa-logo.png" alt="Melwa Logo" width="120" height="33" />
            {/* <h1 className="h3 mb-3 fw-normal text-center">Login</h1> */}

            {/* Username input with validation */}
            <div className="form-floating mb-3">
              <input
                type="text"
                className={`form-control ${usernameError ? "is-invalid shake" : ""}`}
                id="floatingUsername"
                placeholder="User Name"
                autoComplete="off"
                value={username}
                onChange={(e) => handleInputChange(e, setUsername, setUsernameError, 20)}
                required
                style={{ outline: "none", boxShadow: "none" }}
              />
              <label htmlFor="floatingUsername">Username</label>
              {usernameError && <div className="invalid-feedback">{usernameError}</div>}
            </div>

            {/* Password input with validation */}

            <div className="form-floating mb-3">
              <input
                type={showPassword ? "text" : "password"}  // Change input type based on the state
                className={`form-control ${passwordError ? "is-invalid shake" : ""}`}
                id="floatingPassword"
                placeholder="Password"                
                autoComplete="new-password"
                inputMode="text" 
                value={password}
                onChange={(e) => handleInputChange(e, setPassword, setPasswordError, 30)}
                required
                style={{ outline: "none", boxShadow: "none" }}
              />
              <label htmlFor="floatingPassword">Password</label>
              {passwordError && <div className="invalid-feedback">{passwordError}</div>}

              {/* Button to toggle password visibility */}
              <button
                type="button"
                onClick={togglePasswordVisibility}
                style={{
                  position: "absolute",
                  right: "10px",
                  top: "50%",
                  transform: "translateY(-50%)",  
                  background: "none",
                  outline: "none",
                  border: "none",
                  fontSize: "20px",
                  cursor: "pointer",
                }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>

            {/* <div className="form-floating mb-3">
              <input
                type="password"
                className={`form-control ${passwordError ? "is-invalid shake" : ""}`}
                id="floatingPassword"
                placeholder="Password"
                autoComplete="current-password" 
                value={password}
                onChange={(e) => handleInputChange(e, setPassword, setPasswordError, 30)}
                required
                style={{ outline: "none", boxShadow: "none" }}
              />
              <label htmlFor="floatingPassword">Password</label>
              {passwordError && <div className="invalid-feedback">{passwordError}</div>}
            </div> */}

            {/* Submit button */}
            <button className="btn w-100 py-2" type="submit" style={{ backgroundColor: "#ED1C24", border: "none", color: "white" }}>
              {loading ? "Logging in..." : "Login"}
            </button>


          </form>
        </div>
      </div>
        )}
    </>
  );
}

export default LoginPage;
